module.exports = __webpack_public_path__ + "img/4fcc4e4.jpg";